const useStyles = () => {
	return {
		skillsContainer1: 'my-5 w-full h-full text-gray-300 mt-[100px] ',
		skillsContainer2: 'max-w-[1000]  p-4 flex flex-col justify-center',
		titleSkills: 'text-4xl inline border-b-4 border-gray-300 ',
		p2: 'py-4 ',
		divContainerSkills:
			'w-full grid grid-cols-2 sm:grid-cols-5 gap-4 text-center ring-white ring-2 p-8 rounded-md bg-black/50',
		skillsDiv: '',
		skillsImg: 'w-20 mx-auto',
		skillsP: 'my-4',
	};
};

export default useStyles;
